import { CssBaseline } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client"; // <--- changement ici

import 'leaflet/dist/leaflet.css';
import App from "./components/App";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import * as serviceWorker from "./serviceWorker";
import Themes from "./themes";

// Crée la racine React 18
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <LayoutProvider>
    <UserProvider>
      <ThemeProvider theme={Themes.default}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </UserProvider>
  </LayoutProvider>
);

// Service worker
serviceWorker.unregister();